module.exports = __webpack_public_path__ + "img/exploreArrow.9d378e25.svg";